import { render, staticRenderFns } from "./ActivacionMasiva.vue?vue&type=template&id=1898dc56&scoped=true&"
import script from "./ActivacionMasiva.vue?vue&type=script&lang=js&"
export * from "./ActivacionMasiva.vue?vue&type=script&lang=js&"
import style0 from "./ActivacionMasiva.vue?vue&type=style&index=0&id=1898dc56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1898dc56",
  null
  
)

export default component.exports